import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ProgramNavDropdown from 'components/ProgramNavDropdown'

import { NavTabLink, NavTabSet } from './component.styles'

class ProgramNav extends Component {
  state = { openDropdownKey: null }

  onDropdownOpenChange = (dropdownKey, isOpen) => {
    this.setState(({ openDropdownKey }) => {
      if (isOpen) return { openDropdownKey: dropdownKey }
      return openDropdownKey === dropdownKey ? { openDropdownKey: null } : null
    })
  }

  onClick = route => {
    const { goToProgram } = this.props
    // previously there was more complex logic to handle this, but route-service returns
    // full paths to learn (starting from the root) so we can just use the route directly:
    goToProgram && goToProgram(route)
  }

  render() {
    const { programs } = this.props
    const { openDropdownKey } = this.state
    if (!programs) {
      return null
    }
    return (
      <NavTabSet
        data-testid="program-nav-tabset"
        isElevated={!!openDropdownKey}
      >
        {programs.map((program, i) => {
          const { children, isSelected, route, title } = program || {}

          if (!route || !title || !program) {
            return null
          }

          const unitNumber = i + 1
          const isActive = isSelected || false
          const isLast = programs.length === i + 1
          const unitId = `${title}`
          const dataTestId = `nav-tab-${unitId}-${unitNumber}`
          const search = location?.search
          const dropdownItems = children?.map(child =>
            child.route ? { ...child, route: child.route + search } : child,
          )
          return (
            <ProgramNavDropdown
              items={dropdownItems}
              key={dataTestId}
              label={title}
              onNavigate={this.onClick}
              onOpenChange={isOpen =>
                this.onDropdownOpenChange(dataTestId, isOpen)
              }
            >
              <NavTabLink
                dataTestId={dataTestId}
                isActive={isActive}
                isLast={isLast}
                onClick={() => {
                  this.onClick(route + search)
                }}
              >
                {title}
              </NavTabLink>
            </ProgramNavDropdown>
          )
        })}
      </NavTabSet>
    )
  }
}

ProgramNav.propTypes = {
  goToProgram: PropTypes.func.isRequired,
  location: PropTypes.shape({ pathname: PropTypes.string }).isRequired,
  programs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      route: PropTypes.string,
      isSelected: PropTypes.bool,
      entryId: PropTypes.string,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          kind: PropTypes.string,
          title: PropTypes.string,
          route: PropTypes.string,
          isSelected: PropTypes.bool,
        }),
      ),
    }),
  ),
}

export default ProgramNav
